<template>
  <footer>
    <!-- Footer Start-->
    <div class="footer-main">
      <div class="footer-area footer-padding">
        <div class="container">
          <div class="row justify-content-between">
            <div class="col-lg-3 col-md-4 col-sm-8">
              <div class="single-footer-caption mb-30">
                <!-- logo -->
                <div class="footer-logo">
                  <a href="index.html">
                    <img height="100em" src="/assets/img/logo/logo2_footer.png" alt />
                  </a>
                </div>
                <div class="footer-tittle">
                  <div class="footer-pera">
                    <p class="info1">Available on the App Store</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-5">
              <div class="single-footer-caption mb-50">
                <div class="footer-tittle">
                  <h4>Quick Links</h4>
                  <ul>
                    <li>
                      <a :href="downloadLinks.android">Android</a>
                    </li>
                    <li>
                      <a :href="downloadLinks.ios">Apple</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="col-lg-2 col-md-4 col-sm-7">
              <div class="single-footer-caption mb-50">
                <div class="footer-tittle">
                  <h4>Support</h4>
                  <ul>
                    <li>
                      <router-link to="/web/contact">Report a bug</router-link>
                    </li>
                    <li>
                      <router-link to="/web/privacy">Privacy Policy</router-link>
                    </li>
                    <li>
                      <router-link to="/web/privacy">Terms & Conditions</router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- Copy-Right -->
          <div class="row align-items-center">
            <div class="col-xl-12">
              <div class="footer-copy-right">
                <p>
                  Copyright &copy; {{year}}
                  All rights reserved
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Footer End-->
  </footer>
</template>

<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
      downloadLinks: config.downloadLinks
    };
  }
};
</script>

<style>
</style>
